import { Avatar, Box, IconButton, Modal, Paper, Typography } from "@mui/material";

function TestimonialModal({ open, onClose, testimonial }) {
    return (
        <Modal
                        open={open}
                        onClose={onClose}
                        aria-labelledby="testimonial-modal"
                        aria-describedby="full-testimonial-text"
                    >
                        <Paper sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: { xs: '90%', sm: '80%', md: '60%' },
                            maxWidth: 700,
                            p: 4,
                            outline: 'none',
                            maxHeight: '90vh',
                            overflow: 'auto'
                        }}>
                            <Box sx={{ position: 'relative' }}>
                                <IconButton 
                                    onClick={onClose}
                                    sx={{ position: 'absolute', top: -12, right: -12 }}
                                >
                                    ✕
                                </IconButton>
                                
                                <Typography variant="h5" component="h2" gutterBottom>
                                    {testimonial?.name}'s Testimonial
                                </Typography>
                                
                                <Typography variant="body1" sx={{ mt: 2, mb: 3 }}>
                                    "{testimonial?.description}"
                                </Typography>
                                
                                <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
                                    <Avatar 
                                        src={testimonial?.image} 
                                        alt={testimonial?.name}
                                        sx={{ width: 50, height: 50, mr: 2 }}
                                    />
                                    <Box>
                                        <Typography variant="subtitle1" color="primary.main">
                                            {testimonial?.name}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {testimonial?.position}, {testimonial?.company}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Paper>
                    </Modal>
    );
}

export default TestimonialModal;